import React from "react";
import PropTypes from "prop-types";
import styles from "./map-banner.module.scss";
import closeIcon from "../../../public/img/close-icon.svg";
import peopleIcon from "../../../public/img/people-icon.svg";
import adultsObeseIcon from "../../../public/img/adults-obese.svg";
import atsiIcon from "../../../public/img/atsi.svg";
import smokingIcon from "../../../public/img/smoking.svg";
import inactiveIcon from "../../../public/img/insufficient-physical-activity.svg";
import arrayToSentence from "array-to-sentence";
import { startsWithAVowel } from "../../helpers/formatters";
import { regionMatcher } from "../../helpers/label-mapper";

const populationDataItems = [
  {
    key: "population2018",
    icon: peopleIcon,
    label: "population",
    type: "number",
  },
  {
    key: "indigenous2018",
    icon: atsiIcon,
    label: "Aboriginal and Torres Straight Islander people",
    type: "percent",
  },
  {
    key: "percentAdultsInsufficientPhysicalActivity2020",
    icon: inactiveIcon,
    label: "adults - no or insufficient physical activity",
    type: "percent",
  },
  {
    key: "percentAdultsOverweightObese2020",
    icon: adultsObeseIcon,
    label: "adults - overweight or obese",
    type: "percent",
  },
  {
    key: "percentAdultsSmokedDaily2020",
    icon: smokingIcon,
    label: "adults smoke daily",
    type: "percent",
  },
];

const MapBanner = ({
  council,
  children,
  comparing,
  onCloseClicked,
  councilsInSameRegion,
  setActiveCouncil,
}) => {
  const rawRegionName = council.classification;
  const region = regionMatcher(rawRegionName);
  const { populationData } = council;
  return (
    <div className={styles.mapBanner} data-comparing={comparing}>
      <button className={styles.closeButton} onClick={onCloseClicked}>
        <img src={closeIcon} alt="" />
      </button>
      <h2 className={styles.mapBannerHeading}>{council.name}</h2>
      {council.name !== "Children's Health" && (
        <div className={styles.populationData}>
          {populationDataItems.map((x) => {
            const isApplicable = populationData[x.key] > 0;
            return (
              <div className={styles.populationDataItem} key={x.key}>
                <div className={styles.populationDataIcon}>
                  <img src={x.icon} alt="" />
                </div>
                <div className={styles.populationDataValue}>
                  <div className={styles.number}>
                    {x.type === "currency" && "$"}
                    {isApplicable
                      ? populationData[x.key].toLocaleString("en", {
                          useGrouping: true,
                        })
                      : "N/A"}
                    {x.type === "percent" && isApplicable && "%"}
                  </div>
                  <div className={styles.text}>{x.label}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {council.name === "Children's Health" ? (
        <p className={styles.p}>
          Children’s Health is a specialist statewide hospital and health
          service and is not geographically bound.
        </p>
      ) : (
        <p className={styles.p}>
          {council.name} is {startsWithAVowel(region) ? "an" : "a"} {region}{" "}
          HHS. The other {region} HHSs are{" "}
          {councilsInSameRegion.map((council, i) => {
            const onClick = (e) => {
              e.preventDefault();
              setActiveCouncil(council.id);
            };
            const isLast = i === councilsInSameRegion.length - 1;
            const isSecondLast = i === councilsInSameRegion.length - 2;
            if (isLast) {
              return (
                <React.Fragment key={council.name}>
                  {" "}
                  and{" "}
                  <a onClick={onClick} className={styles.link}>
                    {council.name}.
                  </a>
                </React.Fragment>
              );
            }
            if (isSecondLast) {
              return (
                <a key={council.name} onClick={onClick} className={styles.link}>
                  {council.name}
                </a>
              );
            }

            return (
              <React.Fragment key={council.name}>
                <a onClick={onClick} className={styles.link}>
                  {council.name}
                </a>
                ,{" "}
              </React.Fragment>
            );
          })}
        </p>
      )}

      <p className={styles.p} style={{ minHeight: comparing ? 70 : 0 }}>
        Hospital{council.hospitals.length > 1 ? "s" : ""} in {council.name}:{" "}
        {arrayToSentence(council.hospitals) + "."}
      </p>

      {council.name !== "Children's Health" && (
        <div className={styles.mapBannerLegend}>
          <span> This demographic data was sourced from the</span>
          <a
            className={styles.externalLink}
            href="https://www.health.qld.gov.au/research-reports/reports/public-health/cho-report/current"
            rel="noopener noreferrer"
            target="_blank"
          >
            2020 Chief Health Officer report
          </a>
          .
        </div>
      )}
    </div>
  );
};

MapBanner.propTypes = {
  council: PropTypes.object,
};

export default MapBanner;



// WEBPACK FOOTER //
// ./src/components/council-map-container/map-banner.js